import { IEstadoTiendaResponse, IWebhookResetResponse } from '../types/responses'
import { axiosInstanceIntegraciones } from '../../../utils/axiosGlobalUtils'

export const GetEstadoTienda = async (tenant: string, codLocal: string) =>
  (await axiosInstanceIntegraciones.get(`/${tenant}/locales/${codLocal}/conexion`)) as IEstadoTiendaResponse

export const ResetWebHook = async (tenant: string, codLocal: string) =>
  (await axiosInstanceIntegraciones.post(`/${tenant}/locales/${codLocal}/webhooks/reset`)) as IWebhookResetResponse
